(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.fancyScrollLogoEl = document.querySelector('#fancy-scroll-logo');
      if(this.fancyScrollLogoEl){
        //this.fancyScrollLogo(this.currentScrollTop);
        this.onScroll(); //Needed for refreshes of the home page when viewing down from the top.
      }      

      this.heroImageEl = document.querySelector('.random-hero-images'); 
      if(this.heroImageEl){
        this.headerWrapper = document.querySelector('.header-wrapper');
        this.homePageScrollHeader(this.currentScrollTop); 
      }        

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      if(this.fancyScrollLogoEl){
        this.fancyScrollLogo(scrollTop);
      }

      if(this.heroImageEl){
        this.homePageScrollHeader(scrollTop);
      }        

      this.currentScrollTop = scrollTop;
    }
    
    fancyScrollLogo(scrollTop){
      let animationStopsAt, changeZindexAt, widthMultiplier, widthOffset, topMultiplier, topffset;
      if(window.matchMedia("(max-width: 989px)").matches){
        animationStopsAt = 35; //pixels
        changeZindexAt = 20; //pixels
        widthMultiplier = -1;
        widthOffset = 50; //percent 
        topMultiplier = -0.4; 
        topffset = 16; //vw
      }else{ 
        animationStopsAt = 220; //pixels
        changeZindexAt = 200; //pixels
        widthMultiplier = -0.3;
        widthOffset = 70; //percent
        topMultiplier = -0.025;      
        topffset = 6; //vw
        //if(scrollTop > changeZindexAt){
        //  topMultiplier = -0.3;  
        //}
        console.log(scrollTop);
      }
      if(scrollTop < animationStopsAt){
        this.fancyScrollLogoEl.classList.remove('scrolled-past');
        //this.classList.remove('header-wrapper--border-bottom');
        if(scrollTop > changeZindexAt){
          this.fancyScrollLogoEl.style.zIndex=5; 
          document.querySelector('.foreground').style.zIndex=2;
        }else{
          this.fancyScrollLogoEl.style.zIndex=3;
          document.querySelector('.foreground').style.zIndex=4;
        }
        this.fancyScrollLogoEl.style.width = (widthMultiplier * scrollTop + widthOffset)+"%";
        this.fancyScrollLogoEl.style.top = (topMultiplier * scrollTop + topffset)+"vw";
      }else{
        this.fancyScrollLogoEl.classList.add('scrolled-past');
        //this.classList.add('header-wrapper--border-bottom');
      }
    }

    homePageScrollHeader(scrollTop){
      let opacity = 0;
      let color = '#FFF';
      if(scrollTop > (this.heroImageEl.offsetHeight/2)){
        opacity = (scrollTop - (this.heroImageEl.offsetHeight/2)) / 100 * 2; // Fade in over 50 pixels from halfway down the hero image
        if(opacity > 1){
          opacity = 1;
          color = '#FFFFFF';
        }
      }
      this.headerWrapper.style.backgroundColor = 'rgba(24,24,24,'+opacity+')';
      this.headerWrapper.style.color = color;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();
})();
